/* ⚛ REACT */
import React from "react";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { ChangeEquipamentDataList } from '../../../../Redux/Actions';

/* 🎨 STYLES */
import { Container, ContentContainer, ChildsContainer, RemoveAllButton} from "./styles";

const ListEquipamentos = (props) => {
    let childs = React.Children.toArray(props.children);
    let active = childs.length > 0;

    return(
        <Container $Active={active} id={props.id}>
            <ContentContainer>
                <ChildsContainer>
                    {childs.map(child => (
                        child
                    ))}                    
                </ChildsContainer>
                {childs.length > 1 &&
                <RemoveAllButton onClick={()=> {
                    store.dispatch(ChangeEquipamentDataList([]))
                    localStorage.setItem('equipamentDataList', JSON.stringify([]))
                }}>
                    Remover todos
                </RemoveAllButton>}
            </ContentContainer>
        </Container>
    )
}

export default ListEquipamentos;